import { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
// import chairman from'../Assets/Images/chairman.jpg'

import LazyLoad from 'react-lazyload';
import { getPrincipalMessage } from "../Service/Api";
const PrincipalMessage = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },   
  ];
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management", link: "", subMenu: [
        { label: "Director-Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ]
    },

    { label: "International Collaborations", link: "/partnership" },
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    { label: "Gallery", link: "/Gallery", subMenu: [{ label: "Photo Gallery", link: "/Gallery" }, { label: "Video Gallery", link: "/VideoGallery" },] },
  ]
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-about2.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle pageTitle="Management" breadEnd="Patrons Message" breadMid="Patrons Message" />

              <h4 className="color-red">Patron's Message</h4>
            </div>
          </div>
          {data?.length > 0 ? data?.filter((div) => div.category === "President").map((item, index) => (
            <div className="row justify-content-center mt-4" key={index}>
              <div className="col-md-12">
              
                <div className="wt-team-1"> <div className="wt-media"><LazyLoad> <img src={`https://webapi.entab.info/api/image/${item.attachments}`} alt="Lotus Valley School, Gurgaon" className="img-fluid" /></LazyLoad> </div></div>
                <p className="color-green font-bold font-normal">{item.name}  <br /> {item.designation}  Padma Bhushan Awardee </p>
                <p dangerouslySetInnerHTML={{ __html: item.message }}></p>
              
             
              </div>
            </div>
          )) : emptyArray.map((data, index) => (<div key={index} className='row'>

          </div>
          ))}

        </div>
      </div>
      <Footer />
    </>
  )
}

export default PrincipalMessage